export default "__VITE_ASSET__CGuX0BEw__"